import { useSelector } from "react-redux";
import "./AllEntityCharge.scss"
import { useLocation, useNavigate } from "react-router-dom";
import { ScaleLoader } from "react-spinners";
import { motion } from "framer-motion";
import moment from "moment";
import Select from "react-select";
import React, { useEffect, useState, forwardRef, useImperativeHandle } from "react";
import newRequest from "../../../utils/newRequest";
import CircularButton, { CustomLoadingButton } from "../../../components/ui/CustomButton";
import { customSelectStyles_dark, customSelectStyles_light } from "../../../components/ui/CustomSelect.jsx";
import ConfirmDialog from "../../../components/confirmDialog/confirmDialog.jsx";
import { ToggleSwitch } from "../../../components/toogle/ToggleSwitch.jsx";
import { useTranslation } from "react-i18next";
import {
    DialogActions,
    Dialog,
    DialogTitle,
    DialogContent,
    Tooltip,
    Table,
    TableContainer,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    Paper,
    Chip,
    TablePagination,
} from "@mui/material";
import { MdDelete } from "react-icons/md";
import { showToast } from "../../../toastService.js";
import { formatStringToNumberV2 } from "../../../utils/genericFunctions.js";

const AllEntityCharge = forwardRef(({ documentEnabled, entityDocid }, ref) => {
    console.log(`AllEntityCharge running...entityDocid ... ${entityDocid}`);
    const { t } = useTranslation();
    const { currentUser } = useSelector((state) => state.user);
    const { currentTheme } = useSelector((state) => state.theme);
    const navigate = useNavigate();
    const [isProcessing, setIsProcessing] = useState(false);
    const [isProcessingTitle, setIsProcessingTitle] = useState(t('pleaseWait'));
    const [selectedCharge, setSelectedCharge] = useState(null);
    const [entityCharges, setEntityCharges] = useState([]);
    const [criteriaList, setCriteriaList] = useState([]);
    const [endChargeTypes, setEndChargeTypes] = useState([]);
    const [endChargeBasis, setEndChargeBasis] = useState([]);

    const fetchEntityCharges = async () => {
        try {
            const res = await newRequest.get(`/allEntityCharge/findAll/${entityDocid}`);
            console.log(`setEntityData  ${JSON.stringify(res.data, null, 2)}`);
            setEntityCharges(res.data);
        } catch (err) {
            console.log(err);
        }
    };

    const updateCharges = async () => {
        try {
            // const changedCharges = entityCharges.filter((obj) => obj.changed_xx === "Y");
            for (let i = 0; i < entityCharges.length; i++) {
                await newRequest.put(
                    `/allEntityCharge/upd/${entityCharges[i]._id}`,
                    {
                        ac_charge_code: entityCharges[i].ac_charge_code,
                        ac_charge_type: entityCharges[i].ac_charge_type,
                        ac_charge_basis: entityCharges[i].ac_charge_basis,
                        ac_charge_name: entityCharges[i].ac_charge_name,
                        ac_charge_rate: formatStringToNumberV2(entityCharges[i].ac_charge_rate),
                        ac_charge_rate_per: formatStringToNumberV2(entityCharges[i].ac_charge_rate_per),
                        ac_enabled: entityCharges[i].ac_enabled,
                        ac_criteria: entityCharges[i].ac_criteria
                    }
                );
            }
        } catch (err) {
            console.log(err);
        }
    };

    useImperativeHandle(ref, () => ({
        updateCharges,
        refreshCharges: fetchEntityCharges,
    }));

    const setCriteria = async () => {
        try {
            const options = ["Default", "Air", "Sea", "Road", "MN-Freq", "QT-Freq", "HY-Freq", "FY-Freq", "LS-Freq"].map((sc) => ({
                value: sc,
                label: sc,
            }));
            setCriteriaList(options);
        } catch (error) {
            console.error("Error fetching entity types:", error);
        }
    };

    const setChargeTypes = async () => {
        try {
            const options = ["Levy", "Charge", "Loading", "Discount", "VAT", "WTAX", "OtherTax"].map((sc) => ({
                value: sc,
                label: sc,
            }));
            setEndChargeTypes(options);
        } catch (error) {
            console.error("Error fetching tax types:", error);
        }
    };

    const setChargeBasis = async () => {
        try {
            const options = ["Sum Insured", "Net Premium", "Gross Premium", "Fixed Amount"].map((sc) => ({
                value: sc,
                label: sc,
            }));
            setEndChargeBasis(options);
        } catch (error) {
            console.error("Error fetching entity types:", error);
        }
    };

    const handleChargeChange = (value, rowId, field) => {
        setEntityCharges((prevData) =>
            prevData.map((item) =>
                item._id === rowId
                    ? { ...item, [field]: value, changed_xx: "Y" }
                    : item
            )
        );
    };

    useEffect(() => {
        if (entityDocid !== undefined) {
            fetchEntityCharges();
        }
    }, [entityDocid]);

    useEffect(() => {
        setCriteria();
        setChargeTypes();
        setChargeBasis();
    }, []);

    return (
        <motion.div
            className="all-entity-charge"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1, transition: { duration: 1 } }}
            exit={{ opacity: 0, transition: { duration: 1 } }}
        >
            <div className="all-entity-wrapper">
                <div className="table-content">
                    <TableContainer component={Paper} sx={{ border: 'none', boxShadow: 'none' }} className="table-container">
                        <Table sx={{ width: "max-content", border: 'none' }}>
                            <TableHead className="tablehead">
                                <TableRow className="tablerow">
                                    <TableCell className="table-cell center" style={{ maxWidth: "50px" }}>
                                        #
                                    </TableCell>
                                    <TableCell className="table-cell left" style={{ width: "auto" }}>
                                        <span>{t('name').toUpperCase()}</span>
                                    </TableCell>
                                    <TableCell className="table-cell left" style={{ maxWidth: "130px" }}>
                                        <span>{t('criteria').toUpperCase()}</span>
                                    </TableCell>
                                    <TableCell className="table-cell left" style={{ maxWidth: "130px" }}>
                                        <span>{t('type').toUpperCase()}</span>
                                    </TableCell>
                                    <TableCell className="table-cell left" style={{ maxWidth: "130px" }}>
                                        <span>{t('basis').toUpperCase()}</span>
                                    </TableCell>
                                    <TableCell className="table-cell right" style={{ maxWidth: "120px" }}>
                                        <span>{t('rate').toUpperCase()}</span>
                                    </TableCell>
                                    <TableCell className="table-cell right" style={{ maxWidth: "100px" }}>
                                        <span>{t('ratePer').toUpperCase()}</span>
                                    </TableCell>
                                    <TableCell className="table-cell center" style={{ maxWidth: "80px" }}>
                                        <span>{t('enabled').toUpperCase()}</span>
                                    </TableCell>

                                    {["admin", "superadmin"].includes(currentUser.user_type_xx) &&
                                        documentEnabled === "Y" &&
                                        <TableCell className="table-cell center" style={{ maxWidth: "60px" }}>
                                            <span>{t('action').toUpperCase()}</span>
                                        </TableCell>}
                                </TableRow>
                            </TableHead>
                            <TableBody className="tablebody">
                                {entityCharges?.map((row, index) => (
                                    <TableRow
                                        key={row?._id}
                                        className={`${selectedCharge?._id === row._id ? "tablerow current" : "tablerow"}`}
                                        onClick={async () => setSelectedCharge(row)}
                                    >
                                        <TableCell className="table-cell center" style={{ maxWidth: "50px" }}>
                                            {index + 1}
                                        </TableCell>
                                        <TableCell className="table-cell left" style={{ width: "auto" }}>
                                            <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
                                                <span className="sub-title">{row?.ac_charge_name}</span>
                                                <span className="sub-title soft" style={{ fontSize: "10px" }}>{row?.ac_charge_code}</span>
                                            </div>
                                        </TableCell>
                                        <TableCell className="table-cell left" style={{ maxWidth: "130px" }}>
                                            <Select
                                                id="ac_criteria"
                                                name="ac_criteria"
                                                menuPortalTarget={document.body}
                                                styles={{
                                                    ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                                    menuPortal: base => ({
                                                        ...base,
                                                        zIndex: 9999,
                                                    })
                                                }}
                                                width="120px"
                                                height="32px"
                                                dropdownHeight={3 * 42}
                                                value={criteriaList.find((option) => option.value === row?.ac_criteria) || null}
                                                onChange={(selectedOption) => handleChargeChange(selectedOption?.value, row._id, "ac_criteria")}
                                                options={criteriaList}
                                                placeholder={t('criteria')}
                                                isDisabled={documentEnabled === "N"}
                                            />
                                        </TableCell>
                                        <TableCell className="table-cell left" style={{ maxWidth: "130px" }}>
                                            <Select
                                                id="ac_charge_type"
                                                name="ac_charge_type"
                                                menuPortalTarget={document.body}
                                                styles={{
                                                    ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                                    menuPortal: base => ({
                                                        ...base,
                                                        zIndex: 9999,
                                                    })
                                                }}
                                                width="120px"
                                                height="32px"
                                                dropdownHeight={3 * 42}
                                                value={endChargeTypes.find((option) => option.value === row?.ac_charge_type) || null}
                                                onChange={(selectedOption) => handleChargeChange(selectedOption?.value, row._id, "ac_charge_type")}
                                                options={endChargeTypes}
                                                placeholder={t('type')}
                                                isDisabled={documentEnabled === "N"}
                                            />
                                        </TableCell>
                                        <TableCell className="table-cell left" style={{ maxWidth: "130px" }}>
                                            <Select
                                                id="ac_charge_basis"
                                                name="ac_charge_basis"
                                                menuPortalTarget={document.body}
                                                styles={{
                                                    ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                                    menuPortal: base => ({
                                                        ...base,
                                                        zIndex: 9999,
                                                    })
                                                }}
                                                width="125px"
                                                height="32px"
                                                dropdownHeight={3 * 42}
                                                value={endChargeBasis.find((option) => option.value === row?.ac_charge_basis) || null}
                                                onChange={(selectedOption) => handleChargeChange(selectedOption?.value, row._id, "ac_charge_basis")}
                                                options={endChargeBasis}
                                                placeholder={`${t('basis')}`}
                                                isDisabled={documentEnabled === "N"}
                                            />
                                        </TableCell>
                                        <TableCell className="table-cell right" style={{ maxWidth: "120px" }}>
                                            <div className="input-item-with-label" style={{ width: "100%" }}>
                                                <input
                                                    id="ac_charge_rate"
                                                    name="ac_charge_rate"
                                                    type="text"
                                                    value={row?.ac_charge_rate}
                                                    placeholder="0.00"
                                                    style={{ width: "100%", textAlign: "right" }}
                                                    className="form-input-item table"
                                                    onChange={(e) => handleChargeChange(e.target.value, row._id, "ac_charge_rate")}
                                                    disabled={!["admin", "superadmin"].includes(currentUser.user_type_xx) || documentEnabled === "N"}
                                                />
                                            </div>
                                        </TableCell>
                                        <TableCell className="table-cell right" style={{ maxWidth: "100px" }}>
                                            <div className="input-item-with-label" style={{ width: "100%" }}>
                                                <input
                                                    id="ac_charge_rate_per"
                                                    name="ac_charge_rate_per"
                                                    type="text"
                                                    value={row?.ac_charge_rate_per}
                                                    placeholder="0.00"
                                                    style={{ width: "100%", textAlign: "right" }}
                                                    className="form-input-item table"
                                                    onChange={(e) => handleChargeChange(e.target.value, row._id, "ac_charge_rate_per")}
                                                    disabled={!["admin", "superadmin"].includes(currentUser.user_type_xx) || row?.ac_charge_basis === "Fixed Amount" || documentEnabled === "N"}
                                                />
                                            </div>
                                        </TableCell>
                                        <TableCell className="table-cell center" style={{ maxWidth: "80px" }}>
                                            <ToggleSwitch
                                                id={row._id}
                                                value={row.ac_enabled}
                                                onChange={(newValue) => handleChargeChange(newValue, row._id, "ac_enabled")}
                                                label=""
                                                labelPosition="end"
                                                labelWidth="max-content"
                                                border="N"
                                                disabled={documentEnabled === "N"}
                                            />
                                        </TableCell>
                                        {["admin", "superadmin"].includes(currentUser.user_type_xx) &&
                                            documentEnabled === "Y" &&
                                            <TableCell className="table-cell center" style={{ maxWidth: "60px" }}>
                                                <CircularButton
                                                    currentTheme={currentTheme}
                                                    onClick={async () => {
                                                        try {
                                                            const res = await newRequest.delete(`/allEntityCharge/del/${row?._id}`);
                                                            if (res.data?.msg === "deleted") {
                                                                setEntityCharges((prevData) => prevData.filter(param => param._id !== row?._id));
                                                                showToast(t('removed'), "success");
                                                            } else {
                                                                showToast("Error removing charge!", "error");
                                                            }
                                                        } catch (error) {
                                                            console.log(error);
                                                        }
                                                    }}
                                                    color="#E53935"
                                                    icon={<MdDelete />}
                                                    width={"30px"}
                                                    height={"30px"} />
                                            </TableCell>}
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </div>
            </div>
            {isProcessing && (
                <motion.div
                    className="processing-dialog"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1, transition: { duration: 1 } }}
                    exit={{ opacity: 0, transition: { duration: 1 } }}
                >
                    <div className="processing-wrapper">
                        <span className='main-title'>{isProcessingTitle || t('pleaseWait')}</span>
                        <ScaleLoader
                            color="var(--primary)"
                            height={50}
                            radius={8}
                            width={4}
                        />
                    </div>
                </motion.div>)}
        </motion.div>
    );
});


export default AllEntityCharge